export default "__VITE_PUBLIC_ASSET__4b55c54a__"